/* eslint-disable no-dupe-keys */
export default {
  ev_charging_station: {
    name: '共享电站',
    // 属性（一般与对象内容匹配）
    prop: {
      name: '站名',
      code: '编号',
      auth_type: '认证类型',
      service_provider: '运营商',
      service_hours: '营业时间',
      parking_fee: '停车说明',
      parking_rule: '停车收费码',
      charging_fee: '充电费用',
      status: '状态',
      support_charging: '支持我方App充电',
      description: '温馨提示',
      service_tel: '服务电话',
      city: '城市',
      address: '地址',
      longitude: '经度',
      latitude: '纬度',
      created_at: '创建时间',
      updated_at: '更新时间',
      guns_count: '枪数量',
      avg_stars: '点评',
      business_info: '营业信息',
      app_tag: 'App可视标签',
      picture: '图片',
      peripheral_facilities: '周边配套',
      recommend: '是否推荐站',
      parking_relief: '停车减免',
      official_certification: '官方认证',
      qrcode: '社区群二维码',
      service_group_qrcode_url: '微信群活码URL',
      parking_type: '停车收费类型',
      community_group: '展示的社群优惠',
      operational_staff: '专属运营人员',
      manager: '场站负责人',
      manager_phone: '场站负责人电话'
    },
    // 列表页字段（列控制使用，需要与列表页匹配）
    columns: {
      name: '站名',
      auth_type: '认证类型',
      service_provider_id: '运营商',
      service_hours: '营业时间',
      parking_fee: '停车说明',
      charging_fee: '充电费用',
      status: '状态',
      support_charging: '支持我方App充电',
      description: '描述',
      service_tel: '服务电话',
      province_id: '省份',
      city_id: '城市',
      address: '地址',
      longitude: '经度',
      latitude: '纬度',
      created_at: '创建时间',
      updated_at: '更新时间',
      guns_count: '枪数量',
      avg_stars: '点评',
      business_info: '营业信息',
      billing_rule_status: '费率状态',
      statuses: '状态',
      app_tag: 'App可视标签',
      station_activities_count: '用户流量',
      peripheral_facilities: '周边配套',
      recommend: '是否推荐站',
      official_certification: '官方认证'
    },
    // Enum的属性
    auth_types: {
      unauth: '未认证',
      auth: '已认证',
      self_support: '自营'
    },
    statuses: {
      open: '对外运营',
      closed: '已下架',
      internal: '对内运营'
    },
    open_flags: {
      public_station: '公共电站',
      private_station: '私人电站'
    },
    station_types: {
      ChargeStation: '监控电站',
      EvcsStation: '互联互通',
      null: '收录的电站'
    },
    peripheral_facilities: {
      toilet: '卫生间',
      convenience_store: '便利店',
      simple_meals: '简餐',
      lounge: '休息室'
    },
    parking_types: {
      charge_parking: '收费停车',
      discount_parking: '减免停车',
      free_parking: '免费停车'
    },
    // Boolean的属性
    support_chargings: { true: '支持充电', false: '不支持充电' },
    recommends: { true: '是', false: '否' },
    official_certifications: { true: '已认证', false: '未认证' },
    // 占位提示
    placeholder: {
      search_keyword: '查询站名/描述/服务电话/地址'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息',
      ev_charging_piles: '充电桩',
      billing_rules: '费率'
    },
    group_titles: {
      base: '基础信息',
      business_info: '业务信息',
      image: '图片',
      location: '位置',
      road_book: '路书'
    },
    // 地图压缩包信息

    // ------ 旧国际化 ------
    filters: {
      statuses: {
        open: '对外营业',
        internal: '对内营业',
        closed: '已下架'
      },
      open_flags: {
        public_station: '开放',
        private_station: '不开放'
      },
      support_chargings: {
        true: '支持充电',
        false: '不可充电'
      }
    },
    tips: {
      charge_station_billing_rule: '当前充电站为「平台自营监控」的电站，无需额外设置费率',
      charge_parking: '收费停车 - 充电不享受减免',
      discount_parking: '减免停车 - 充电享受减免（一定时长）优惠',
      has_parking_relief: '如果有绑定停车减免规则，则不允许修改该「停车收费类型」',
      free_parking: '免费停车 - 不收费'
    },
    attr: {
      fee: '收费',
      time: '时间',
      desc: '描述',
      station_comments_count: '点评数',
      current_total_price: '当前价格'
    },
    // 列表页字段（列控制使用，需要与列表页匹配）
    param_locales: {
      name: '充电站',
      guns_count: '枪数量',
      avg_stars: '点评',
      business_info: '营业信息',
      statuses: '状态',
      app_tag: 'App可视标签',
      created_at: '创建时间',
      updated_at: '更新时间',
      open_flag: '对外开放',
      support_charging: '支持充电',
      auth_type: '站类型',
      created_at: '创建时间',
      updated_at: '更新时间',
      source_type: '站来源',
      billing_rule_status: '费率状态',
      has_pictures: '是否有图',
      province: '省份',
      city: '城市',
      service_provider: '运营商',
      peripheral_facilities: '周边配套',
      power_type: '电源类型'
    },
    // Enum的属性
    source_types: {
      ecmp: '平台监控',
      evcs: '互联互通',
      others: '其他'
    },
    billing_rule_statuses: {
      custom: '自定义',
      evcs: '第三方',
      evcs_custom: '第三方上浮',
      missing: '缺失'
    },
    // Boolean的属性
    has_pictures: { true: '是', false: '否' },
    avg_stars: { 1: '1星', 2: '2星', 3: '3星', 4: '4星', 5: '5星' },
    power_types: {
      ac: '交流',
      dc: '直流'
    },
    // 占位提示
    placeholder: {
      search_keyword: '充电站编号 / 名称',
      input_parking_desc: '请描述停车说明',
      input_sn: '如: 省份 + 地区 + 编号, BJHD0000001',
      input_service_hours: '请输入营业时间',
      input_charging_fee: '输入充电费',
      search_province: '电站所在省份',
      search_city: '电站所在城市',
      search_auth_type: '认证/非认证',
      select_power_type: '直流/交流',
      input_service_group_qrcode_url: '请输入微信群活码URL'
    },
    btn: {
      ev_charing_station: '共享站',
      view_billing_rule: '查看费率',
      manage: '管理',
      upload_pic: '上传图片'
    }
  }
}
